import { createApp } from 'vue';
import Modal from './index.vue';
import { i18n } from '@/lang/i18n';

type Options = {
  title: string;
  sub: string;
  onClose?:()=>void;
}

const $confirm = {
  userExp: (options:Options) => {
    const has = document.querySelector('.user-exp-dialog');
    if (!has) {
      const className = `dialog-${Math.random()}`;
      const div = document.createElement('div');
      div.className = `user-exp-dialog ${className}`;
      const container = document.body;

      const componentInstance = createApp(Modal, {
        title: options.title,
        sub: options.sub,
        onClose: () => {
          options.onClose &&  options.onClose();
          setTimeout(() => {
            container.removeChild(div);
          }, 0);
        }
      });

      componentInstance.use(i18n);
      componentInstance.mount(div);
      container && container.appendChild(div);
    }
    return !has;
  }
};

export default $confirm;

